import React from "react"
import {FormControl, FormErrorMessage, FormLabel} from "@chakra-ui/react"

import {ISelectFormProps} from "./interfaces"


export function FSelect(props: ISelectFormProps) {
    const {
        field,
        label,
        rules,
        initialValue,
        inputOptions,
        register,
        errors,
        options,
        className,
    } = props

    return <FormControl isInvalid={errors[field]} className={className}>
        {/*<label htmlFor="location" className="block text-sm font-medium leading-6 text-gray-900">*/}
        {/*    Location*/}
        {/*</label>*/}
        <FormLabel htmlFor={field}>{label}</FormLabel>
        <select
            defaultValue={initialValue}
            id={field} {...inputOptions}
            {...register(field, rules)}
            className="block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6">
            <option key="" value=""></option>
            {options.map(({label, value}) => <option key={value} value={value}>{label}</option>)}
        </select>
        <FormErrorMessage>
            {errors[field] && errors[field].message}
        </FormErrorMessage>
    </FormControl>
}

